import React, { useState } from "react";
import { Helmet } from "react-helmet";

import FeatureFour from "../../components/features/FeatureFour";
import Testimonial from "../../components/testimonial/Testimonial";
import FooterTwo from "../../components/footer/FooterTwo";
import CopyRightTwo from "../../components/footer/CopyRightTwo";
import './customerSupport.css'
import Profile1 from "../../assets/images/assets/Profile 1.png";
import Profile2 from "../../assets/images/assets/Profile 2.png";
import Profile3 from "../../assets/images/assets/Profile 3.png";
import Profile4 from "../../assets/images/assets/Profile 4.png";

import HeaderThree from "../../components/header/HeaderThree";

import AppImage from "../../assets/Home/Game-creation/AppDevelopedss.png";
import CLIENTS from "../../assets/Home/Game-creation/CLIENTSs.png";
import PROJECTS from "../../assets/Home/Game-creation/PROJECTSss.png";
import TeamMembers from "../../assets/Home/Game-creation/TeamMemberss.png";
import YearsImage from "../../assets/Home/Game-creation/YearsofExperiences.png";
import countries from "../../assets/Home/Game-creation/Countriess.png";

import PricingFive from "../../components/pricing/PricingFive";
import BlockMetaData from "../../components/fancy-text-block/BlockMetaData";
import LatestProduct from "../../components/vr-landing/LatestProduct";
import PortfolioDemo2 from "../../components/portfolio/PortfolioDemo2";

import reacts from "../../assets/Prgm-Icon/React.png";
import ethereum from "../../assets/Prgm-Icon/Ethereum.png";
import flutter from "../../assets/Prgm-Icon/Flutter.png.svg";
import mean from "../../assets/Prgm-Icon/Mean.png";
import mern from "../../assets/Prgm-Icon/Mern.png";
import solana from "../../assets/Prgm-Icon/Solana.png";
import unre1 from "../../assets/Prgm-Icon/Unreal-1.png";
import unre2 from "../../assets/Prgm-Icon/Unreal.png";
import TestimonialSix from "../../components/testimonial/TestimonialSix";
import BlogStyle5 from "../../components/blog/BlogStyle5";
import SignUp from "../inner-pages/features/miscellaneous/SignUp";
import OurLatestBlogs from "../../assets/Sub-component/OurLatestBlogs";
import AboutCustomerSupport from "../inner-pages/pages/about/AboutCustomerSupport";
import ContactUs from "../../components/contact/ContactUs";
import ContactUs2 from "../../components/contact/Contactus2";
import Faq from "../inner-pages/pages/Faq";
import FaqHome from "../../components/faq/FaqHome";
import Image from "./3dimages";
import launchingimage from "../../assets/Launchingimage.png"
import clientimage from '../../assets/Feedback_imgs/Frame 15.png'

const CustomerSupport = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const blockchainServices = [
    {
      buttonHeading: "Blockchain Development",
      cards: [
        {
          heading: "Private Blockchain Development",
          subheading:
            "We utilize blockchain technology to create specialized, highly secure data protection that supports your business enterprise's growth with pertinent solutions.",
        },
        {
          heading: "Public Blockchain Development",
          subheading:
            "Developed on a public blockchain for decentralized control, our dApps and smart contracts are launched and maintained by an engaged community and end-to-end solutions.",
        },
        {
          heading: "Blockchain Consulting Services",
          subheading:
            "We deliver strategic planning, workable studies for profitable workshops, and training for a blockchain advancement that efficiently empowers your company. ",
        },
        {
          heading: "Hyperledger Development",
          subheading:
            "We create and implement chains for hyperledger fabric that offer customized hyperledger solutions for an effective implementation by forming blockchain consortiums.",
        },
      ],
    },
    {
      buttonHeading: "Crypto Development",
      cards: [
        {
          heading: "Cryptocurrency creation",
          subheading:
            "Crypto are designed and developed on the basis of blockchain and consensus technology like Proof of Work (POW) and Proof of Stake (POS) for delivering top-tier security and integrated solutions.",
        },
        {
          heading: "Cryptocurrency Exchange ",
          subheading:
            "We build a secure, seamless crypto trading experience with centralized and decentralized exchange platforms for optimal liquidity, security, and streamlined performance.",
        },
        {
          heading: "White Label Crypto Exchange",
          subheading:
            "Our white-label crypto exchange solutions provide rapid deployment, full brand customization, regulatory compliance, and advanced margin/futures trading for instant market entry.",
        },
        {
          heading: "Smart Contract Development",
          subheading:
            "We develop and deploy smart contracts with integrated security audits to ensure reliability and legal compliance while automating and safeguarding business processes.",
        },
      ],
    },
    {
      buttonHeading: "Audit Services",
      cards: [
        {
          heading: "Smart Contract Audits",
          subheading:
            "Evaluating smart contract code thoroughly for security flaws and producing regular reports that highlight threats and provide workable fixes for optimum security and performance.",
        },
        {
          heading: "Compliance Audits",
          subheading:
            "Conducting audits on a regular basis to confirm regulatory standards and compliance gaps, and providing practical suggestions to guarantee blockchain solutions.",
        },
        {
          heading: "Performance Audits",
          subheading:
            "We enhance speed and scalability, address inefficiencies, and compare our results to industry norms to maintain blockchain performance at its best.",
        },
        {
          heading: "Security Audits",
          subheading:
            "We provide thorough security audits and penetration testing to find and fix infrastructure flaws and improve your defenses against online attacks.",
        },
      ],
    },
    {
      buttonHeading: "NFT Services",
      cards: [
        {
          heading: "NFT Marketplace Development",
          subheading:
            "Our user-friendly interfaces and safe smart contracts create an uninterrupted environment for minting, purchasing, and selling NFTs.",
        },
        {
          heading: "NFT Consultation and Strategy",
          subheading:
            "Raiden has expertise in providing complete protection for the NFT ecosystem by consulting, developing strategies, conducting market research, and providing legal advice.",
        },
        {
          heading: "NFT Token Development",
          subheading:
            "We ensure reliable functionality and vulnerability protection while maintaining the development of encrypted tokens with minting management.",
        },
        {
          heading: "NFT Integration and Support",
          subheading:
            "With the help of our expert technical support, effective marketing strategies, execution, and maximized reach and impact, your NFT integration is likely to be successful.",
        },
      ],
    },
    {
      buttonHeading: "Game Development ",
      cards: [
        {
          heading: "2D Game Development",
          subheading:
            "Our 2D game development ensures accessible and efficient production. Games offer crisp, memorable gameplay that's easy to pick up on any platform. ",
        },
        {
          heading: "AAA Game Development",
          subheading:
            "Raiden offers AAA game development with its sophisticated story, cutting-edge graphics, and engrossing gameplay. It offers immersive experiences that boost a company's brand.",
        },
        {
          heading: "MMORPG Game Development",
          subheading:
            "Our MMORPG facilitates social interactions and manages engagement for the long term. The players benefit from intricate gameplay, rich storytelling, and excellent graphics.",
        },
        {
          heading: "Board Game Development ",
          subheading:
            "Raiden's board games provide screen-free and tangible entertainment through in-person interaction, as well as cognitive benefits such as strategic thinking. To show the potential of your business. ",
        },
      ],
    },
    {
      buttonHeading: "Extended Reality",
      cards: [
        {
          heading: "Augmented Reality",
          subheading:
            "Raiden's Augmented Reality (AR) blends digital and real-world content. This service creates an accessible method for improving marketing and education. AR technology creates an engaging experience. ",
        },
        {
          heading: "Virtual Reality",
          subheading:
            "Our Virtual Reality (VR) technology allows for an intricate digital world experience via a headset. We provide our clients with deep VR solutions that help industries like manufacturing and healthcare.",
        },
        {
          heading: "Mixed Reality ",
          subheading:
            "Our MR services enable the virtual object to interact with the real world by merging the digital and physical realms. This technology is seen as the way of the future for many businesses and teamwork.",
        },
        {
          heading: "Substitutional Reality",
          subheading:
            "SR services incorporate highly specialised technology that modifies users' memories and substitutes a pre-recorded image for the real-world scene. By pushing the limits of immersive technology.",
        },
      ],
    },
  ];

  return (
    <>
 
  <img className="Bg-image"
    src={launchingimage} 
  
    alt="Launching"
/>
    <div className="main-page-wrapper overflow-hidden"  >
    
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      {/* End Page SEO Content */}

      {/* =============================================
		   Start Header
		   ============================================== */}
      <HeaderThree />

      {/* hero banner */}

      <>
        <Helmet>
          <title>
            Appointment Scheduling || Deski-Saas & Software React Template
          </title>
        </Helmet>
        {/* End Page SEO Content */}
        <div className="container	">
          <div
            className="  height-vh "
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Left Content */}
            <div className="   topheader-margin">
              <div className=" font-raleway mt-3">
                <h1 className="text-center h1-heading ">
                  Ingenuity Unbound: Reimagining the Digital World
                </h1>
                <p className=" text-center mt-3 h1-para fw-less">
                  One pixel, one line of code—where creativity sparks innovation
                </p>
              </div>
            </div>

            {/* Right Contact Form */}
          </div>
        </div>
        
      </>

      {/* below hero banner */}
      <Image/>

      <div className="fancy-feature-twentyTwo     " id="product " style={{background: "linear-gradient(90deg, #F15A24 0%, #F1CC31 100%)"}}>
        <div className=" py-5 px-lg-5 px-3">
          <div className="title-style-ten hero-banner-below ">
            <div className="row align-items-start">
              <div className="col-lg-7">
                <h2
                  className="h2-heading text-lg-start text-lg-start text-center  "
                  style={{
                    fontFamily: "Raleway ",
                    fontWeight: 700,
                    color: "white",
                  }}
                >
                 Unified Tech Solutions for End-to-End Digital Transformation

                </h2>
              </div>
              <div className="col-lg-5">
                <p style={{ color: "white" }} className="mb-4  h1-para text-center text-lg-start ">
                  Since 2022, we’ve been enabling businesses to accelerate their digital evolution. Our multi-platform solutions ensure efficiency, scalability, and seamless execution—delivering measurable results from concept to completion.
                </p>
                <div
                  className="d-flex justify-content-center "
                
                >
                  <a
                    href="/about-us"
                    className="theme-btn-nine theme-btn-nine-bg-gradient h1-para px-3 py-2"
                  >
                    About Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* service */}

      <div className="fancy-feature-four ">
        <div className="bg-wrapper">
          <div className="container">
            
            {/* End .title */}

            <div className="inner-content">
              {/* <FeatureFour /> */}
            </div>
            {/* End .inner-content */}
          </div>
        </div>
      </div>

      {/*  */}

      {/* 	=====================================================
				Pricing Section Five
			===================================================== */}
      <div
        id="pricing"
        className="pricing-section-five mb-75 mt-75 sm-mt-50 sm-mb-50"
      >
        <div className="container">
          <div className="row align-items-start flex-row">
           <div className="col-lg-6 d-flex flex-wrap">
        <div className="row g-4">
          {[
            { img: YearsImage, value: "5+", label: "Experience" },
            { img: TeamMembers, value: "50+", label: "Team Members" },
            { img: AppImage, value: "50+", label: "App Developed" },
            { img: CLIENTS, value: "25+", label: "Clients" },
            { img: PROJECTS, value: "40+", label: "Projects" },
            { img: countries, value: "15+", label: "Countries" },
          ].map((stat, index) => (
            <div key={index} className="col-6 col-md-6 col-lg-4 text-center">
              <img
                src={stat.img}
                alt={stat.label}
                style={{
                  width: "100px",
                  marginBottom: "15px",
                  transition: "transform 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
              />
              <h4 className="h3-heading font-gordita">{stat.value}</h4>
              <h5 className="h1-para">{stat.label}</h5>
            </div>
          ))}
        </div>
      </div>


            <div className="col-lg-6">
              <div className="pricing-table-area-five md-mt-60">
                <PricingFive />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*  */}

      <div
        className="fancy-feature-twentyTwo   mb-80  py-5 marb"
        id="product"
        style={{ background: "linear-gradient(90deg, #F15A24 0%, #F1CC31 100%)"  }}
      >
        <div className=" px-lg-5">
          <div className="title-style-ten hero-banner-below   md-mb-20">
            <div className="row align-items-start">
              <div className="col-lg-7">
                <h2
                  style={{ color: "white" }}
                  className="font-raleway fw-bold h2-heading w-lg-100 px-2 px-lg-0 "
                >
                  Boosting Business Progress With Smart Solutions
                </h2>
              </div>
              <div className="col-lg-5  ">
                <p
                  className=" mb-4 lh-base h3-para  ps-1 text-center text-lg-start "
                  style={{
                    marginTop: "17px",
                    color: "white",
                    fontSize: "22px",
                   
                  }}
                >
                  With the expertise of a prominent development company, you may
                  receive robust software solutions, modernize systems, and rely
                  on cutting-edge technology for growth opportunities.
                </p>
                <div
                  className="d-flex justify-content-center "
                
                >
                  <a
                    href="/contactus"
                    className="theme-btn-nine h1-para py-2 px-4 "
                  >
                    Let's Connect
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* new actice components */}
      <div className="container  " id="product">
        <div className="row align-items-center d-flex" >
          {/* Left - Buttons */}
         <div
  className="col-md-4 p-4 rounded"
  style={{
    background: "white",            
    border: "none",                 
    borderRadius: "10px",          
    padding: "20px",
    boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.13)" 
  }}
>

            <h3 className="mb-4 text-bold card-title-heading h2-heading  " style={{color:'black'}}>
              Raiden’s Tech Advancements with Innovation
            </h3>
            <div className="d-flex flex-column gap-2">
              {blockchainServices.map((service, index) => (
                <button
                  key={index}
                  className={`h3-heading  ${
                    activeIndex === index
                      ? "theme-btn-nine1"
                      : "theme-btn-nine-no-bg"
                  } text-start`}
                  onClick={() => setActiveIndex(index)}
                  // style={{
                  //   transition: 'all 0.3s ease',
                  //   cursor: 'pointer',
                  //   marginBottom: '10px'
                  // }}
                >
                  {service.buttonHeading}
                </button>
              ))}
            </div>
          </div>

          {/* Right - Cards */}
          <div className="col-md-8 h-100"style={{ minHeight: "500px" }}>
            <div className="row row-cols-1 row-cols-md-2 gy-4">
              {blockchainServices[activeIndex].cards.map((card, i) => (
                <div 
                  className="col" 
                  key={`card-${activeIndex}-${i}`} 
                  style={{ 
                    marginTop: "30px",
                    transition: 'all 0.3s ease-in-out',
                    opacity: 1
                  }}
                >
                  <div className="card card-body-div h-100 border-0">
                    <div className="card-body">
                      <h3 className="card-title h3-heading btn-gradient">
                        {card.heading}
                      </h3>
                      <p className="card-text h3-para">{card.subheading}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Why Choose Raiden */}

      <div className="mt-80  mart   ">
        <div className="text-center">
          {/* <div className="feature-img-area"></div> */}
        </div>
        <div className="block-style-one ">
          <h2
            className="text-center fw-bold mb-4 h2-heading "
            style={{ fontFamily: "Raleway, sans-serif" }}
          >
            Why Choose Raiden?
          </h2>
          <div className="container">
            <div className="d-lg-flex justify-content-between inner-container">
              <BlockMetaData />
            </div>
          </div>
          {/* /.container */}
        </div>
        {/* /.block-style-one */}
      </div>

      {/* Technology Stack */}

      {/*  */}

      <div
        className="fancy-feature-thirtySix lg-container pb-100 pt-100 md-pb-50 padt bg-white"
        id="product"
      >
        <div className="container position-relative">
          <div className="row">
            <div className="col-lg-3   my-lg-auto my-0">
              <div className="title-style-eleven md-mb-40 text-lg-left">
                <h2
                  className="text-black h2-heading "
                  style={{ fontSize: "40px" }}
                >
                  Our Core Strengths and Services
                </h2>
                <p className="mt-3 h1-para " >
                  Our core strengths and strategies reward you with quality
                  success by combining blockchain services, client
                  recommendations, and optimistic solutions that assist you in
                  reaching your objectives.
                </p>
              </div>
            </div>
            <div className="col-lg-9  ">
              <div className="product_slider_one vr-landing-slider">
                <LatestProduct />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*  */}

      {/* /.fancy-text-block-seven */}

      {/* development expertise */}
      <div
        className="fancy-portfolio-one pt-28 pb-100 padb  md-py-150 "
        id="product"
      >
        <div className="container">
          <div className="title-style-six">
            <h2
              className="text-center fw-bold h2-heading "
              style={{ fontSize: "40px" }}
            >
              Maximize Your Projects with <br />
              <span className="text-decoration-none text-dark">
                {" "}
                Our Experience
              </span>
            </h2>
          </div>

          <div className="portfolioSliderOne arrow-top-right pt-50 md-pt-30 ">
            <PortfolioDemo2 />
          </div>
        </div>
      </div>

      <div
  className="fancy-feature-twentyTwo mt-80 mart bg-dark py-5"
  style={{
    background: "linear-gradient(90deg, #F15A24 0%, #F1CC31 100%)"
  }}
  id="product"
>
        <div className="px-lg-5 px-3 ">
          <div className="title-style-ten hero-banner-below  mb-40 md-mb-20">
            <div className="row align-items-start">
              <div className="col-lg-7 mt-4">
                <h2 className="font-raleway fw-bold text-white h2-heading  text-lg-start">
                  Next-Level Gaming, access VR and Blockchain
                </h2>
              </div>
              <div className="col-lg-5 mt-lg-4">
                <p
                  className="   text-white font-raleway h1-para  text-lg-start text-center fw-less "
                  style={{ fontSize: 22}}
                >
                  Dive into a Realm of Cutting-Edge Entertainment with Our
                  Exciting Gaming, VR, and Blockchain Solutions. Unleash the
                  innovation, and let's forge the future of play and engagement
                  together today.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ContactUs2 />
      {/*  */}

      <div className="client-feedback-slider-six pb-60 padb " id="feedback">
        <div className="inner-container">
          <div className="container">
            <div className="row">
              <div className="col-12"></div>
            </div>
          </div>
          <div className="clientSliderSix arrow-middle-center-demo">
            <TestimonialSix />
          </div>
        </div>
        {/* /.inner-container */}
      </div>


      {/* Client Feedback */}
     <div className="client-feedback-slider-one pt-50 pb-100 md-pb-80">
  <div className="shapes-holder">
    <img
      src={clientimage}
      alt="Client"
      style={{
        width: '400px',
        height: '400px',
        borderRadius: '50%',
        objectFit: 'cover',
        boxShadow: '0 12px 28px rgba(0, 0, 0, 0.25)',
        marginLeft: 'auto',
        marginRight: '0px',
        display: 'block',
        transition: 'transform 0.3s ease-in-out',
        marginTop:'172px'
      }}
      onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
      onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
    />
  </div>

  <div className="container">
    <div className="row">
      <div className="col-lg-6 ms-auto">
        <div className="feedback-meta">
          <div className="watermark font-gilroy-bold">Feedback</div>
          <div className="clientSliderOne">
            <Testimonial />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


      {/* blog */}

      <div className="marb mb-80">
        <OurLatestBlogs />
      </div>

      {/* contact us */}

     {/* <FaqHome/> */}

      {/* Footer Style Two */}
      <footer className="theme-footer-two pt-100 md-pt-80">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
       </>
  );
};

export default CustomerSupport;
